import { EnumLang } from "../types/EnumLang";


export const getLanguageNavigator = () => {
    const langNavigator = navigator.language.substring(0, 2);
    if (
      langNavigator === EnumLang.ca ||
      langNavigator === EnumLang.en ||
      langNavigator === EnumLang.es ||
      langNavigator === EnumLang.oc
    ) {
      return EnumLang[langNavigator];
    } else {
      return EnumLang.ca;
    }
  };